import { Helmet } from "react-helmet";
import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios'
import { Heading, Button, Input, Text } from "../../components";
import Navbar from "components/Navbar";
import Footer from "components/Footer"

const apiUrl = process.env.REACT_APP_API_URL;

export default function ScheduleDemo() {
  const [message, setMessage] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [demoDate, setDemoDate] = useState('')
  const [demoTime, setDemoTime] = useState('')

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log('api url: ' + apiUrl)
      setMessage("Sending request ...")
      const response = await axios.post(`${apiUrl}/scheduleDemo`, { fullName, email, phone, companyName, demoDate, demoTime});
      console.log('register ok')
      setMessage("Your request has been received! A confirmation email will be sent to you with the details of your schedule.")
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error);
      } else if (err.request) {
        setError("Network error. Please check your internet connection and try again.");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
      
    }
  };


  return (
    <>
      <Helmet>
        <title>Schedule a Demo</title>
        <meta
          name="description"
          content="Schedule a demo with TRG, we'll show you the cutting edge risk methodology in your investment"
        />
      </Helmet>

      <div className="w-full bg-gray-300">
        <div className="container-xs py-6 md:px-5">
          <Navbar />
        </div>

        {/* message */}
        <div className="flex w-full max-w-[1440px] justify-center px-22 ">
              <Text as="p" className="text-[20px] h-[30px] font-extrabold text-red-700 cursor-pointer">
                {message}
              </Text>
        </div>      


        <div className="relative h-[780px] bg-gray-300">
          <div className="flex items-center justify-center py-8 w-screen">
            {/* 
            <div className="flex flex-col items-center gap-3 self-stretch p-12 md:p-5 bg-yellow-100">*/}
            <div className="flex flex-col items-center w-[500px] md:w-full gap-5 px-9 py-10 md:py-5 sm:p-5 bg-gray-900_02" >
              <Heading
                size="textlg"
                as="h1"
                className="text-center text-[28px] font-extrabold leading-[140%] text-white-a700 md:w-full "
              >
                Schedule a Demo
              </Heading>

              <form onSubmit={handleSubmit} className="flex w-[90%] flex-col items-center gap-3 md:w-full">
                <Input
                  value={fullName}
                  onChange={(e)=>setFullName(e.target.value)} 
                  shape="square"
                  type="text"
                  name="FullName Input"
                  placeholder={`Full Name`}
                  className="w-full"
                  style={{ backgroundColor: '#262528', border: 'none' }}
                />
                
                <Input 
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)} 
                  shape="square" 
                  type="email" 
                  name="Email Input" 
                  placeholder={`Email Address`} 
                  className="w-full"
                  style={{ backgroundColor: '#262528', border: 'none' }}
                  
                />

                <Input 
                  value={phone}
                  onChange={(e)=>setPhone(e.target.value)} 
                  shape="square" 
                  type="tel" 
                  name="Phone number" 
                  placeholder={`Phone Number`} 
                  className="w-full"
                  style={{ backgroundColor: '#262528', border: 'none' }}
                  
                />

                <Input
                  value={companyName}
                  onChange={(e)=>setCompanyName(e.target.value)} 
                  shape="square"
                  type="text"
                  name="Comanpy Name Input"
                  placeholder={`Company Name`}
                  className="w-full border-0 !text-gray-500 "
                  
                  style={{ backgroundColor: '#262528',border: 'none' }}
                  
                />

                <Input 
                  value={demoDate}
                  onChange={(e)=>setDemoDate(e.target.value)} 
                  shape="square" 
                  type="date" 
                  name="Demo date" 
                  label="Demo Date:"
                  placeholder={`Demo Date`} 
                  className="w-full"
                  style={{ backgroundColor: '#262528', border: 'none' }}
                  
                />

                <Input 
                  value={demoTime}
                  onChange={(e)=>setDemoTime(e.target.value)} 
                  shape="square" 
                  type="time" 
                  name="Demo time" 
                  label="Demo Time:"
                  placeholder={`Demo Time`} 
                  className="w-full"
                  style={{ backgroundColor: '#262528', border: 'none' }}
                  
                />

                <Button type="submit" color="indigo_A700" size="sm" shape="square" className="self-stretch px-[34px] py-[10px] sm:px-5">
                  Submit
                </Button>
                {error && <p style={{ color: 'red' }}>{error}</p>}
              </form>
            </div>
          </div>        
        </div>        

        <div>
          <Footer />
        </div>
  
      </div>
    </>
  );
}
